import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CxoneEtlRecalculationService } from '../cxone-etl-recalculation.service';
import { MetricTypes } from '../cxone-etl-recalculation-modal.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ETLRecalculationStatus } from '../../cxone-etl-data-recalculation/cxone-etl-data-recalculation.model';

@Component({
    selector: 'cv-cxone-recalculation-metric-view',
    templateUrl: './cxone-recalculation-metric-view.component.html',
    styleUrls: ['./cxone-recalculation-metric-view.component.scss']
})
export class CxoneRecalculationMetricViewComponent implements OnInit {
    @Output() selectedMetricList: EventEmitter<string[]> = new EventEmitter();
    @Input() metricsInProgress: ETLRecalculationStatus[];
    public metricList: string[];
    public selectedMetricDefList: string[] = [];
    public selectAllChecked = false;
    public showSpinner: boolean;
    public standardMetricDefList: any;
    public isLocalizationSectionLoaded: boolean;
    public checkboxes: boolean[] = [];
    public disable = false;

    constructor(
        private cxoneEtlRecalculation: CxoneEtlRecalculationService,
        private cvLocalizationService: CVLocalizationService,
    ) { }

    async ngOnInit(): Promise<void> {
        this.showSpinner = true;
        await this.loadLocalization();
        this.isLocalizationSectionLoaded = true;
        await this.initializeMetricsListData();
        this.cxoneEtlRecalculation.metricListChange$.subscribe(metrics => {
            if (this.cxoneEtlRecalculation.getEmittedValue === 'detailed-view') {
                this.checkboxes = [];
                this.selectedMetricDefList = [];
                if (metrics && metrics.length > 0) {
                    metrics.forEach(item => {
                        this.checkboxes[item] = true;
                        this.selectedMetricDefList.push(item);
                    });
                }
                this.cxoneEtlRecalculation.setEmittedValue = undefined;
            }
        })
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('ETL_Recalculation_Modal');
        }
        catch {
            console.error('Failed to load localization for ETL_Recalculation_Modal');
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Recalculation_Modal", key, defaultValue);
        return baseString;
    }

    async initializeMetricsListData() {
        const recalculationData = await this.cxoneEtlRecalculation.loadRecalculationMetricData(true);
        const metricData = recalculationData
            .filter(inputObject => inputObject.Type === MetricTypes.Standard)
            .map((inputObject) => ({
                MetricID: inputObject.MetricID.toString(),
                MetricName: inputObject.MetricName,
                disabled: false
            }));

        this.metricsInProgress.forEach(item => {
            const metricNames = item.definitions.split(',').map(def => def.trim());

            metricData.forEach(metric => {
                if (metricNames.includes(metric.MetricName.trim())) {
                    metric.disabled = true;
                }
            });
        });

        this.standardMetricDefList = metricData;
        const metricIDs = this.standardMetricDefList.map(data => data.MetricID);
        const filteredDisabledMetrics = metricIDs
            .map(metricID => this.standardMetricDefList.find(metric => metric.MetricID === metricID))
            .filter(metric => !metric.disabled);

        this.metricList = filteredDisabledMetrics.map(data => data.MetricID);

        this.showSpinner = false;
    }

    handleCheckBoxClicked(metric: string, isChecked: boolean) {
        if (isChecked) {
            this.selectedMetricDefList.push(metric);
        } else {
            let index = this.selectedMetricDefList.indexOf(metric);
            this.selectedMetricDefList.splice(index, 1);
        }
        this.cxoneEtlRecalculation.setEmittedValue = 'list-view';
        this.selectedMetricList.emit(this.selectedMetricDefList);
    }
}
